import React, { useState, useEffect } from 'react';
import { Modal, Form, DatePicker, Input, Button, Space, Tree, Tooltip, Upload, Popconfirm, message } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { faEye, faDownload, faTrash, faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons';
import { faFolderPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { upload_tree_file } from '../../services/poa/post_support';
import moment from 'moment';
import './PoaObservaciones.css';
const PoaMediosVerificacion = ({ isVisible, onClose, record }) => {
    const [isFirstModalVisible, setIsFirstModalVisible] = useState(isVisible);
    const [isSecondModalVisible, setIsSecondModalVisible] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const [expandedKeys, setExpandedKeys] = useState([]);
    const { DirectoryTree } = Tree;
    const truncateText = (text, maxChars) => {
        return text.length > maxChars ? text.slice(0, maxChars) + '...' : text;
    };

    const normalizeString = (str) => str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    useEffect(() => {
        setIsFirstModalVisible(isVisible);
    }, [isVisible]);

    useEffect(() => {
        // Configura las claves para expandir los nodos de nivel 1
        setExpandedKeys(getDefaultExpandedKeys(record));
    }, [record]);

    // Función para obtener las claves expandidas
    const getDefaultExpandedKeys = (record) => {
        return (transformToTreeData(record)[0]?.children || []).map(child => child.key);
    };
    const handleCancel = () => {
        setIsFirstModalVisible(false);
        setIsSecondModalVisible(false);
        onClose();
    };

    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    const showSecondModal = () => {
        setIsFirstModalVisible(false);
        setIsSecondModalVisible(true);
    };

    const handleSecondModalCancel = () => {
        setIsSecondModalVisible(false);
        setIsFirstModalVisible(true);
    };

    const handleEdit = (key) => {
        console.log('Edit node with key:', key);
    };

    const onSelect = (keys, info) => {
        console.log('Trigger Select', keys, info);
    };

    const onExpand = (keys, info) => {
        setExpandedKeys(keys); // Actualiza el estado de expandedKeys
    };

    // Función para generar claves únicas
    const generateKey = (prefix, index) => `${prefix}-${index}`;

    // Transformar datos a la estructura de treeData
    const transformToTreeData = (record) => {


        if (!record || typeof record !== 'object') {
            return [];
        }

        const { indicador, key, datoIndicador } = record;

        if (!datoIndicador || typeof datoIndicador !== 'object') {
            return [];
        }

        const { key: datoKey, medioVerificacion } = datoIndicador;

        // Transformar medioVerificacion a nodos hijos
        const medioVerificacionNodes = (medioVerificacion || []).map((medio, index) => {
            const soportesMVA = (medio.soportesMVA || []).map((soporte, soporteIndex) => ({
                title: (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ display: 'flex', alignItems: 'center', width: '310px' }}>
                            <Tooltip title={soporte.nombreSoporte}>
                                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                    <strong>Soporte: </strong>{truncateText(normalizeString(soporte.nombreSoporte), 55)}
                                </span>
                            </Tooltip>
                        </div>
                        <div style={{ marginLeft: 'auto' }}>
                            <Tooltip title="Ver">
                                <button
                                    className="btn-primary-lis"
                                    style={{ background: 'none', border: 'none', color: 'inherit', padding: 0, font: 'inherit', cursor: 'pointer' }}
                                >
                                    <FontAwesomeIcon icon={faEye} />
                                </button>
                            </Tooltip>
                            <span style={{ margin: '0 2px', fontSize: '16px' }}> | </span>
                            <Tooltip title="Descargar Archivo">
                                <button
                                    className="btn-primary-lis"
                                    style={{ background: 'none', border: 'none', color: 'inherit', padding: 0, font: 'inherit', cursor: 'pointer' }}
                                >
                                    <FontAwesomeIcon icon={faDownload} />
                                </button>
                            </Tooltip>
                            <span style={{ margin: '0 2px', fontSize: '16px' }}> | </span>
                            <Tooltip title="Eliminar">
                                <Popconfirm
                                    title='Eliminación de archivo'
                                    description="¿Segur@ que quieres eliminar este archivo?"
                                    okText="Sí"
                                    cancelText="No"
                                    icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                                >
                                    <button
                                        className="btn-primary-lis"
                                        style={{ background: 'none', border: 'none', color: 'inherit', padding: 0, font: 'inherit', cursor: 'pointer' }}
                                    >
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                </Popconfirm>
                            </Tooltip>
                        </div>
                    </div>
                ),
                key: generateKey(datoKey, `soporte-${soporteIndex}`),
                isLeaf: soporte.isLeaf === 'true',
            }));

            return {
                title: (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ display: 'flex', alignItems: 'center', width: '250px' }}>
                            <Tooltip title={medio.medioVerificacion}>
                                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                    <strong>Medio De Verificación: </strong>{truncateText(normalizeString(medio.medioVerificacion), 55)}
                                </span>
                            </Tooltip>
                        </div>
                        <div className="container" style={{ display: 'flex', alignItems: 'center' }}>
                            <Tooltip title="Descargar Carpeta">
                                <button
                                    className="btn-primary-lis"
                                    style={{ background: 'none', border: 'none', color: 'inherit', font: 'inherit', cursor: 'pointer' }}
                                >
                                    <FontAwesomeIcon icon={faDownload} />
                                </button>
                            </Tooltip>
                            <span style={{ fontSize: '16px', paddingRight: '0px', paddingLeft: '5px' }}> | </span>
                            <Tooltip title="Subir Archivo">
                                <Upload {...getUploadProps(medio)}>
                                    <Button
                                        className="btn-primary-lis"
                                        style={{ background: 'none', border: 'none', color: 'inherit', font: 'inherit', cursor: 'pointer' }}
                                        icon={<FontAwesomeIcon icon={faCloudUploadAlt} />}
                                    />
                                </Upload>
                            </Tooltip>
                            <span style={{ fontSize: '16px', paddingRight: '0px', paddingLeft: '34px' }}> | </span>
                            <Tooltip title="Subir Carpetas">
                                <Upload directory>
                                    <Button
                                        className="btn-primary-lis"
                                        style={{ background: 'none', border: 'none', color: 'inherit', margin: '0 -2px', font: 'inherit', cursor: 'pointer' }}
                                        icon={<FontAwesomeIcon icon={faFolderPlus} />}
                                    />
                                </Upload>
                            </Tooltip>
                            <span style={{ fontSize: '16px', paddingRight: '0px', paddingLeft: '27px' }}> | </span>
                        </div>
                    </div>
                ),
                key: generateKey(datoKey, `medio-${index}`),
                isLeaf: medio.isLeaf,
                children: soportesMVA,
            };
        });

        return [
            {
                title: (
                    <div className="container" style={{ display: 'flex', alignItems: 'center' }}>
                        <Tooltip title={indicador}>
                            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                <strong>Indicador: </strong>{truncateText(normalizeString(indicador), 55)}
                            </span>
                        </Tooltip>
                    </div>
                ),
                key: key,
                children: medioVerificacionNodes,
            }
        ];
    };

    const getUploadProps = (node) => ({
        name: 'file',
        multiple: true,
        showUploadList: false,
        customRequest: async (info) => {
            const { file } = info;
            // Imprimir información del archivo adjunto
            const maxSize = 100 * 1024 * 1024; // 100 MB en bytes
            if (file.size > maxSize) {
                // Mostrar un mensaje de error si el archivo es demasiado grande
                message.error(`El archivo es demasiado grande: ${file.name}`);
                return;
            }
            try {
                const uploadedBy = 'defaultUser'; // Puedes obtener esto de otro lugar si es necesario
                const pathFromClient = 'some/path'; // Establece la ruta del archivo según tu necesidad
                // Llamar al servicio para cargar el archivo
                const response = await upload_tree_file(pathFromClient, file, uploadedBy);
                if (response.status === 'success') {
                    file.serverFileName = response.serverFileName;
                    message.success(`Archivo cargado correctamente: ${file.name}`);
                } else {
                    message.error(`Error en la carga: ${file.name}`);
                }
            } catch (error) {
                message.error(`Error al cargar el archivo: ${error.message}`);
            }
        },
        onClick: (e) => {
            e.stopPropagation();
        },
    });
    const treeData = transformToTreeData(record);

    return (
        <>
            <Modal
                title={<span style={{ fontWeight: 'bold', fontSize: '20px', textAlign: 'center', display: 'block' }}>Cargar Medios de Verificación</span>}
                open={isFirstModalVisible}
                onCancel={handleCancel}
                footer={null}
                width={600}
            >
                <Form layout="vertical" name="form_in_modal">
                    <Space direction="vertical" size={10} style={{ width: '100%' }}>
                        <Form.Item
                            name="date"
                            rules={[{ required: true, message: 'Por favor seleccione una fecha' }]}
                        >
                            <DatePicker
                                value={selectedDate ? moment(selectedDate) : null}
                                onChange={handleDateChange}
                                format="YYYY-MM-DD"
                                style={{ width: '100%' }}
                                placeholder="Fecha y hora"
                            />
                        </Form.Item>
                        <Form.Item
                            name="title"
                            rules={[{ required: true, message: 'Por favor ingrese un título' }]}
                        >
                            <Input showCount maxLength={20} placeholder="Titulo" style={{ width: '100%' }} />
                        </Form.Item>
                        <Form.Item
                            name="observation"
                            rules={[{ required: true, message: 'Por favor ingrese una observación' }]}
                        >
                            <Input.TextArea showCount maxLength={100} placeholder="Observación" style={{ width: '100%' }} />
                        </Form.Item>
                        {treeData.length > 0 ? (
                            <DirectoryTree
                                multiple
                                expandedKeys={expandedKeys}
                                defaultExpandAll={false}
                                onSelect={onSelect}
                                onExpand={onExpand}
                                treeData={treeData}
                            />
                        ) : (
                            <p>No hay datos disponibles.</p>
                        )}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%', padding: '10px' }}>
                            <Button type="primary" style={{ width: '100%' }} htmlType="submit">
                                Guardar
                            </Button>
                            <Button type="primary" style={{ width: '100%' }} onClick={showSecondModal}>
                                Ver Detalles
                            </Button>
                        </div>
                    </Space>
                </Form>
            </Modal>
            <Modal
                title="Detalles del Medio de Verificación"
                open={isSecondModalVisible}
                onCancel={handleSecondModalCancel}
                footer={null}
                width={600}
            >
            </Modal>
        </>
    );
};

export default PoaMediosVerificacion;
